// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ct-map[data-v-0587af99]{width:100%;padding:0 clamp(1.25rem,3vw,3.75rem);background:#fff}.ct-map[data-v-0587af99]  .GMap>div{height:33.25rem}@media(max-width:768px){.ct-map[data-v-0587af99]  .GMap>div{height:unset;aspect-ratio:1/1}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
